<template>
  <ConfigProvider :use-id="useIdFunction">
    <NuxtLoadingIndicator color="#0048A6" :throttle="0" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <VueQueryDevtools />
    <CookieConsentBanner />
  </ConfigProvider>
</template>

<script setup lang="ts">
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
import { authQueries } from "./domains/auth/queries";
const useIdFunction = () => useId();

const queryClient = useQueryClient();
const { data: self, suspense } = useQuery(authQueries.self());
await suspense();
await queryClient.prefetchQuery(authQueries.preferences());

const posthog = usePosthog();
const { checkConsentStatus } = useCookieConsent();

onMounted(() => {
  checkConsentStatus();
});

watch(
  self,
  (donor) => {
    if (!donor) return;
    posthog?.identify(donor.email, {
      name: donor.name,
      email: donor.email,
      circles: donor.members.map(
        (member) => member.organization.defaultUrl.url
      ),
    });
  },
  { immediate: true }
);
</script>
